import { useState } from 'react'
import { RiArrowRightUpLine } from '@remixicon/react'
import styles from './integrations.module.css'

// Prefer the existing local brand assets, with CMS logos as a fallback.
const logos: Record<string, string> = {
  Webhook: 'webhook.png',
  Airtable: 'airtable.png',
  'Google Sheet': 'google-sheet.png',
  Slack: 'slack.png',
  'Lark Suite': 'lark.png',
  Telegram: 'telegram.png',
  'Google Tag Manager': 'google-tag-manager.png',
  'Facebook Pixel': 'facebook-pixel.webp',
  'Google Analytics': 'google-analytics.webp',
  osTicket: 'osticket.png',
  HubSpot: 'hubspot.png',
  MailChimp: 'mailchimp.webp',
  Integromat: 'make.png',
  Zapier: 'zapier.png',
  SupportPal: 'supportpal.png',
  Zendesk: 'zendesk.png',
  Freshdesk: 'freshdesk.png',
  Stripe: 'stripe.png',
  Monday: 'monday.png',
  WordPress: 'wordpress.png',
  Dropbox: 'dropbox.png',
  'Google Drive': 'google-drive.png'
}

function IntegrationCard({ app }: { app: AppModel }) {
  const [failed, setFailed] = useState(false)
  const logo = logos[app.Title]
    ? `/static/integrations/${logos[app.Title]}`
    : app.Logo?.[0]?.presignedUrl
  return (
    <a className={styles.card} href={app.Link} target="_blank" rel="noreferrer">
      <div className={styles.appIdentity}>
        {logo && !failed ? (
          <img
            src={logo}
            alt=""
            width={44}
            height={44}
            loading="lazy"
            onError={() => setFailed(true)}
          />
        ) : (
          <span className={styles.initial} aria-hidden="true">
            {app.Title.slice(0, 1)}
          </span>
        )}
        <h3>{app.Title}</h3>
      </div>
      <p>{app.Overview}</p>
      <span className={styles.cardAction}>
        Setup guide
        <RiArrowRightUpLine aria-hidden="true" />
        <span className="sr-only"> for {app.Title} (opens in a new tab)</span>
      </span>
    </a>
  )
}

export function IntegrationItem({
  heading,
  apps
}: {
  heading: string
  apps: AppModel[]
}): JSX.Element {
  return (
    <section className={styles.group}>
      <div className={styles.groupHeading}>
        <h2>{heading}</h2>
        <span>
          {apps.length} {apps.length === 1 ? 'integration' : 'integrations'}
        </span>
      </div>
      <div className={styles.appGrid}>
        {apps.map(app => (
          <IntegrationCard key={app.Title} app={app} />
        ))}
      </div>
    </section>
  )
}
